export const HOTEL_NUMBER_OF_NIGHTS = 1;
